export default {
    "reference_profile": "Эталонный профиль",
    "team_profile": "ЭИ профиль команды",
};
